import $ from 'jquery';

// Case insensitive contains — registered immediately (no need to wait for page-init-complete)
$.expr[':'].icontains = function (a, i, m) {
    return $(a).text().toUpperCase()
        .indexOf(m[3].toUpperCase()) >= 0;
};
